import { render, staticRenderFns } from "./bthk_raporu.vue?vue&type=template&id=5c835d76&scoped=true&"
import script from "./bthk_raporu.vue?vue&type=script&lang=js&"
export * from "./bthk_raporu.vue?vue&type=script&lang=js&"
import style0 from "./bthk_raporu.vue?vue&type=style&index=0&id=5c835d76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c835d76",
  null
  
)

export default component.exports